import { createI18n } from "vue-i18n";

import translateMap from '@/data/translate.json';

let messages = {};

for (let propName in translateMap) {
    for (let language in translateMap[propName]) {
        if (messages[language] === undefined) {
            messages[language] = {};
        }

        messages[language][propName] = translateMap[propName][language];
    }
}

// //Getting locale, default locale will be 'ja' and the ja will be selected if locale is not supported (Ex: fr, es, de)
// const browserLocale = navigator.language.split('-')[0];
// const supportedLocales = ['ja'];
// // const locale = supportedLocales.includes(browserLocale) ? browserLocale : 'ja';
// const locale = (typeof window !== 'undefined' && window.Cypress) ? 'en' : 'ja';

const i18n = createI18n({
    legacy: false,
    locale: 'ja', //Set always to japanese because the language selection is not implemented yet. It will be implemented in the future.
    fallbackLocale: 'ja',
    messages,
})

export { i18n }
export default i18n